import { render } from "./PantryVirtualEmptyView.vue?vue&type=template&id=7f710794&ts=true"
import script from "./PantryVirtualEmptyView.vue?vue&type=script&lang=ts"
export * from "./PantryVirtualEmptyView.vue?vue&type=script&lang=ts"

import "./PantryVirtualEmptyView.vue?vue&type=style&index=0&id=7f710794&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__